import React, { Suspense, useContext, useEffect, useState } from "react";
import { Button } from "primereact/button";
import {
  AddCycleQuestion,
  GetQuestions
} from "./PMSService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { TostMsg } from "../../../App";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";

const AddQuestion = ({ submitForm, cycleId, openFormWeightage }) => {
  const history = useHistory();
  const userDetails = JSON.parse(localStorage.getItem("User")) || {};
  const [criteriaList, setCriteriaList] = useState([]);
  const [loading, setLoading] = useState(false);
const toster = useContext(TostMsg);
  const [questions, setQuestions] = useState([
    {
      Id: 0,
      SectionId: 0,
      SectionName: "",
      QuestionText: "",
      Weightage: 0,
      SortOrder: 1,
    },
  ]);

  const [errors, setErrors] = useState([]);
  

 

  const getCriteriaMasterList = async () => {
    const params = {
      masterType: "AssessmentCriteria",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    try {
      setLoading(true);
      let response = await GetMasterTypeData(params);

      const data = response?.Data || response?.data || [];

      setCriteriaList(data);
      setLoading(false);
    } catch (error) {

      setCriteriaList([]);
      setLoading(false);
    }
  };

   useEffect(() => {
    console.log(openFormWeightage);
  if (cycleId) {
    getCriteriaMasterList();
    getQuestionsData();
  }
}, [cycleId]);


// ---------------------------------------
// Get Questions
// ---------------------------------------
const getQuestionsData = async () => {
  if (!cycleId) {
  
    return;
  }

  try {
    setLoading(true);

    const params = {
      cycleId: Number(cycleId),
    };
    const response = await GetQuestions(params);

    // Handle different possible API response structures
    const responseData =
      response?.data ??
      response?.Data ??
      response;

    let apiQuestions = [];

    if (Array.isArray(responseData)) {
      apiQuestions = responseData;
    } else if (Array.isArray(responseData?.Questions)) {
      apiQuestions = responseData.Questions;
    } else if (Array.isArray(responseData?.Data)) {
      apiQuestions = responseData.Data;
    } else if (Array.isArray(responseData?.CriteriaQuestions)) {
      apiQuestions = responseData.CriteriaQuestions;
    }


    // If API has no questions, keep one empty row
    if (!apiQuestions.length) {
      setQuestions([
        {
          Id: 0,
          SectionId: 0,
          SectionName: "",
          QuestionText: "",
          Weightage: 0,
          SortOrder: 1,
        },
      ]);

      return;
    }

    // Map API response according to Add Question form structure
    const normalizedQuestions = apiQuestions.map(
      (question, index) => ({
        Id:
          question?.Id ??
          question?.QuestionId ??
          0,

        SectionId:
          question?.SectionId ??
          question?.CriteriaId ??
          question?.AssessmentCriteriaId ??
          0,

        SectionName:
          question?.SectionName ??
          question?.CriteriaName ??
          question?.Criteria ??
          "",

        QuestionText:
          question?.QuestionText ??
          question?.Question ??
          question?.Description ??
          "",

        Weightage:
          Number(
            question?.Weightage ??
            question?.WeightagePercentage ??
            0
          ),

        SortOrder:
          question?.SortOrder ??
          index + 1,
      })
    );

    setQuestions(normalizedQuestions);

    // Reset validation errors according to API question count
    setErrors(normalizedQuestions.map(() => ({})));

  } catch (error) {

    // Keep one empty question row if API fails
    setQuestions([
      {
        Id: 0,
        SectionId: 0,
        SectionName: "",
        QuestionText: "",
        Weightage: 0,
        SortOrder: 1,
      },
    ]);

    setErrors([{}]);

  } finally {
    setLoading(false);
  }
};

  // ---------------------------------------
  // Add Question
  // ---------------------------------------
  const addMoreQuestion = () => {
    setQuestions((prev) => [
      ...prev,
      {
        Id: 0,
        SectionId: 0,
        SectionName: "",
        QuestionText: "",
        Weightage: 0,
        SortOrder: prev.length + 1,
      },
    ]);

    setErrors((prev) => [...prev, {}]);
  };

  // ---------------------------------------
  // Remove Question
  // ---------------------------------------
  const removeQuestion = (index) => {
    if (questions.length === 1) {
      return;
    }

    setQuestions((prev) =>
      prev
        .filter((_, i) => i !== index)
        .map((item, i) => ({
          ...item,
          SortOrder: i + 1,
        })),
    );

    setErrors((prev) => prev.filter((_, i) => i !== index));
  };

  // ---------------------------------------
  // Input Change
  // ---------------------------------------
  const handleChange = (index, field, value) => {
  setQuestions((prev) =>
    prev.map((item, i) => {
      if (i !== index) {
        return item;
      }

      // Section/Criteria selection
      if (field === "SectionId") {
        const selectedCriteria = criteriaList.find(
          (criteria) => Number(criteria?.Id) === Number(value)
        );

        return {
          ...item,
          SectionId: value === "" ? "" : Number(value),
          SectionName: selectedCriteria?.AssessmentCriteria || "",
        };
      }

      // Weightage input
      // Keep "" while user is typing/clearing the field
      if (field === "Weightage") {
        return {
          ...item,
          Weightage: value === "" ? "" : value,
        };
      }

      return {
        ...item,
        [field]: value,
      };
    })
  );

  // Clear individual error when user changes value
  setErrors((prev) =>
    prev.map((error, i) => {
      if (i !== index) {
        return error;
      }

      return {
        ...error,
        [field]: "",
      };
    })
  );
};

  // ---------------------------------------
  // Validation
  // ---------------------------------------
  const validateQuestions = () => {
    const newErrors = questions.map(() => ({}));

    let isValid = true;

    // Cycle ID validation
    // if (!cycleId || Number(cycleId) <= 0) {
    //   alert(
    //     "Assessment Cycle is not available. Please save the Assessment first.",
    //   );

    //   return false;
    // }

    questions.forEach((question, index) => {
      if (!question.SectionId) {
        newErrors[index].SectionId = "Please select criteria.";
        isValid = false;
      }

      if (!question.QuestionText || !question.QuestionText.trim()) {
        newErrors[index].QuestionText = "Question is required.";
        isValid = false;
      } else if (question.QuestionText.trim().length < 3) {
        newErrors[index].QuestionText =
          "Question must be at least 3 characters.";
        isValid = false;
      }

      if (
        question.Weightage === "" ||
        question.Weightage === null ||
        Number(question.Weightage) <= 0
      ) {
        newErrors[index].Weightage = "Weightage must be greater than 0.";
        isValid = false;
      }

      if (Number(question.Weightage) > 100) {
        newErrors[index].Weightage = `Weightage cannot be greater than 100%.`;
        isValid = false;
      }
    });

    const totalWeightage = questions.reduce(
      (total, question) => total + Number(question.Weightage || 0),
      0,
    );

    
    if (Number(totalWeightage) !== 100) {
      toster.current.error(
        `Question weightage must total 100%. Current total: ${totalWeightage}%`,
      );

      isValid = false;
    }

    setErrors(newErrors);

    return isValid;
  };

  // ---------------------------------------
  // Save Questions
  // ---------------------------------------
  const saveQuestions = async (action) => {

    const isValid = validateQuestions();

    if (!isValid) {
      return;
    }

    setLoading(true);

    try {
      const payload = {
        CycleId: Number(cycleId),

        Questions: questions.map((question, index) => ({
          Id: Number(question.Id || 0),

          SectionId: Number(question.SectionId || 0),

          SectionName: question.SectionName || "",

          QuestionText: question.QuestionText?.trim() || "",

          Weightage: Number(question.Weightage || 0),

          SortOrder: index + 1,
        })),
      };

     

      const response = await AddCycleQuestion(payload);

      if (response?.StatusCode === 2000) {
       toster.current.success("Questions saved successfully!");

        if (action === 1) {
          history.push("/Assessment/Cycles");
        } else {
          submitForm("employee");
        }
      } else {
        toster.current.error(
          response?.Message || response?.message || "Unable to save questions.",
        );
      }

    } catch (error) {
    

      toster.current.error(
        error?.response?.data?.Message ||
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong while saving questions.",
      );
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------
  // Total Weightage
  // ---------------------------------------
  const totalWeightage = questions.reduce(
    (total, question) => total + Number(question.Weightage || 0),
    0,
  );

 return (
    <div className="og-card-assessment">
      <div className="ti-div">
        <div className="step-title">
          <i className="fa fa-clipboard-list"></i>Current Cycle Evaluation Setup
        </div>
        <div className="note">
          Current Cycle Section Weight: <strong>{openFormWeightage}%</strong> of final score
        </div>
      </div>
      <div className="step-alert">
        <i class="fa fa-circle-info"></i>
        Weightages within this section must total <strong>100%</strong>. Each question is rated 1–5 by the manager.
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="add-questions">
            <div className="questionslist-title">
              <p>No.</p>
              <p>Criteria</p>
              <p>Question</p>
              <p>Weightage %</p>
              <p></p>
            </div>

                 {questions.map((item, index) => (

        <div
          className="questionlist-detail-cols"
          key={index}
        >

          {/* Number */}
          <strong>
            {index + 1}
          </strong>


          {/* Criteria */}
          <div className="question-field-wrapper">

            <select
              className="form-control"
              value={item.SectionId || ""}
              onChange={(e) =>
                handleChange(
                  index,
                  "SectionId",
                  e.target.value
                )
              }
            >
              <option value="">
                Select Criteria
              </option>

              {criteriaList.map((criteria) => (
                <option
                  key={criteria?.Id}
                  value={criteria?.Id}
                >
                  {criteria?.Name}
                </option>
              ))}
            </select>

            {errors?.[index]?.SectionId && (
              <div className="invalid-feedback d-block">
                {errors[index].SectionId}
              </div>
            )}

          </div>


          {/* Question */}
          <div className="question-field-wrapper">

            <input
              type="text"
              className="form-control"
              placeholder="Enter question / description"
              value={item.QuestionText || ""}
              onChange={(e) =>
                handleChange(
                  index,
                  "QuestionText",
                  e.target.value
                )
              }
            />

            {errors?.[index]?.QuestionText && (
              <div className="invalid-feedback d-block">
                {errors[index].QuestionText}
              </div>
            )}

          </div>


          {/* Weightage */}
          <div className="question-field-wrapper">

            <input
              type="number"
              className="form-control"
              min="1"
              max="100"
              value={item.Weightage ?? 0}
              onChange={(e) =>
                handleChange(
                  index,
                  "Weightage",
                  e.target.value
                )
              }
            />

            {errors?.[index]?.Weightage && (
              <div className="invalid-feedback d-block">
                {errors[index].Weightage}
              </div>
            )}

          </div>


          {/* Delete */}
          <button
            type="button"
            className="question-delete"
            onClick={() => removeQuestion(index)}
            disabled={questions.length === 1}
          >
            <i className="fa fa-times"></i>
          </button>

        </div>

      ))}


          </div>
         <div
      className="question-add"
      onClick={addMoreQuestion}
    >

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        className="bi bi-plus"
        viewBox="0 0 16 16"
      >
        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
      </svg>

      Add Question

    </div>


    {/* Footer */}
    <div className="flex pt-5 justify-content-between text-right">

      {/* Back */}
      <Button
        label="Back"
        severity="secondary"
        className="btn-og btn-og-secondary"
        onClick={() => submitForm("assessment")}
      />


      {/* Right Buttons */}
      <div>

        <Button
          label="Save & Exit"
          className="btn-og btn-og-secondary me-2"
          onClick={() => saveQuestions(1)}
          disabled={loading}
        />

        <Button
          label="Next: Add Employees"
          className="btn-og btn-og-primary"
          icon="fa fa-arrow-right"
          iconPos="right"
          onClick={() => saveQuestions(2)}
          disabled={loading}
        />

      </div>

    </div>

  </div>
  </div>

  {loading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
  </div>
  ); 
};

export default AddQuestion;
